export default function ZoomRoot({ children }) {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  const isSafari =
    ua &&
    /Safari/i.test(ua) &&
    !/(Chrome|Chromium|CriOS|Android|Edg|OPR)/i.test(ua)
  const isWindows = /Windows NT/i.test(ua)
  const isChrome = /(Chrome|Chromium|CriOS)/i.test(ua) && !/(Edg|OPR)/i.test(ua)
  const isWindowsChrome = isWindows && isChrome

  const zoomValue = isSafari ? 0.8 : isWindowsChrome ? 0.95 : 0.95
  const zoomStr = zoomValue.toFixed(2)

  const supportsZoom =
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('zoom', zoomStr)

  const style = supportsZoom
    ? { zoom: zoomValue, height: '100%' }
    : {
        transform: `scale(${zoomValue})`,
        transformOrigin: 'top left',
        width: `calc(100% / ${zoomValue})`,
        height: '100%'
      }

  return <div style={style}>{children}</div>
}
